import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export interface DialogData {
  messageMain: string;
  messageSecondary: string;
}

@Component({
  selector: 'app-dialog-processing-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatButtonModule,
    MatProgressBarModule,
  ],
  templateUrl: './dialog-processing-modal.component.html',
  styleUrl: './dialog-processing-modal.component.scss',
})
export class DialogProcessingModalComponent implements OnInit {
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  displayMainMessage: string = 'Default Message';
  displaySubMessage: string = '';

  ngOnInit(): void {
    this.displayMainMessage = this.data.messageMain;
    this.displaySubMessage = this.data.messageSecondary;
  }
}
